export default __webpack_public_path__ + "static/media/profile.3670cf7f.jpg";